export default "__VITE_ASSET__Dd0S0_9W__"